module.exports = __webpack_public_path__ + "assets/images/project/menu/united-states-thumb.jpg?v=088f67c2";